import { Typography } from "antd";
import { useIntl } from "react-intl";
import { CompetitorTypes } from "~enums/competitorTypes";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { ColumnComponentProperties } from "../../../types";
import { StyledSpace } from "./ScoreColumn.styles";

type EntrantResultPlace = {
  /** 1 = Won; 2 = Lost */
  resultPlace?: 1 | 2 | null;
  /** 1 = Won; 2 = Lost */
  resultSecondaryScorePlace?: 1 | 2 | null;
};

const getTextType = (entrant: EntrantResultPlace) => {
  const resultPlace =
    entrant?.resultPlace === null || entrant?.resultPlace === undefined ? entrant?.resultSecondaryScorePlace : entrant?.resultPlace;

  const won = 1 as const;
  const lost = 2 as const;
  return resultPlace === won ? "success" : resultPlace === lost ? "danger" : "secondary";
};

export const ScoreColumn = (properties: ColumnComponentProperties) => {
  const sportConfiguration = useSportConfiguration();
  const { formatMessage } = useIntl();
  const isEntityCompetitor = sportConfiguration.competitorType === CompetitorTypes.Entity;
  const isPersonCompetitor = sportConfiguration.competitorType === CompetitorTypes.Person;

  const homeEntrant = isEntityCompetitor
    ? properties.value?.homeCompetitor
    : isPersonCompetitor
      ? properties.value?.homeParticipants?.[0]
      : null;
  const awayEntrant = isEntityCompetitor
    ? properties.value?.awayCompetitor
    : isPersonCompetitor
      ? properties.value?.awayParticipants?.[0]
      : null;

  const noneText = formatMessage({
    id: "fixtureListPage.table.column.result.none",
  });
  const homeScore = homeEntrant?.score ?? noneText;
  const homeSecondaryScore = homeEntrant?.secondaryScore;
  const awayScore = awayEntrant?.score ?? noneText;
  const awaySecondaryScore = awayEntrant?.secondaryScore;

  const homeTextType = getTextType(homeEntrant);
  const awayTextType = getTextType(awayEntrant);

  return (
    <StyledSpace>
      <div>
        <Typography.Text type={homeTextType}>{homeScore}</Typography.Text>
        {homeSecondaryScore && (
          <Typography.Text type={homeTextType} className="ml-1">
            {" "}
            ({homeSecondaryScore})
          </Typography.Text>
        )}
      </div>
      :
      <div>
        {awaySecondaryScore && (
          <Typography.Text type={awayTextType} className="mr-1">
            ({awaySecondaryScore}){" "}
          </Typography.Text>
        )}
        <Typography.Text type={awayTextType}>{awayScore}</Typography.Text>
      </div>
    </StyledSpace>
  );
};
